import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getOrCreateGuestAttemptId } from '@/utils/guestAttemptId';

const resolveRole = (session, fallbackRole) => {
  if (session?.user?.role) return session.user.role;
  if (fallbackRole) return fallbackRole;
  return 'student';
};

export const useAuthSessionStore = create(
  persist(
    (set) => ({
      session: null,
      setAuthenticatedSession: (apiResult, type = 'authenticated', fallbackRole) => {
        const role = resolveRole(apiResult, fallbackRole);
        set({
          session: {
            type,
            role,
            user: apiResult?.user || null,
            accessToken: apiResult?.access_token || null,
            refreshToken: apiResult?.refresh_token || null,
            expiresIn: apiResult?.expires_in || null,
            tokenType: apiResult?.token_type || 'Bearer',
          },
        });
      },
      startGuestSession: () => {
        const guestId = getOrCreateGuestAttemptId();
        set({
          session: {
            type: 'guest',
            role: 'student',
            user: {
              id: guestId,
              name: 'Khách trải nghiệm',
              role: 'student',
              account_type: 'guest',
              email: '',
            },
            accessToken: null,
            refreshToken: null,
            expiresIn: null,
            tokenType: null,
          },
        });
      },
      clearSession: () => set({ session: null }),
      updateSessionUser: (updates) =>
        set((state) => {
          if (!state.session) return state;
          return {
            session: {
              ...state.session,
              user: {
                ...(state.session.user || {}),
                ...updates,
              },
            },
          };
        }),
    }),
    {
      name: 'eduquiz-auth-session',
      version: 1,
    },
  ),
);

